import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

import { colors } from 'app/theme/colors'
import { mobile, shadow, space, zIndex } from 'app/theme/tokens'

/**
 * Fixed-position app bar shown only on mobile. Provides the hamburger that
 * opens the existing MainLayout Drawer, plus space for the current page
 * title and an optional right-side action slot.
 *
 *   <MobileTopBar
 *     onMenuClick={() => setDrawerOpen(true)}
 *     title="Mark Attendance"
 *     right={<UnreadBadge count={3} />}
 *   />
 *
 * Pair with a top-padding of `mobile.topBarHeight` on the main content so
 * children aren't covered by this bar.
 */

const Bar = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: calc(${mobile.topBarHeight} + ${mobile.safeAreaTop});
  padding-top: ${mobile.safeAreaTop};
  padding-left: ${space.xs};
  padding-right: ${space.xs};
  display: flex;
  align-items: center;
  gap: ${space.sm};
  background: ${colors.white};
  border-bottom: 1px solid ${colors.borderDefault};
  box-shadow: ${shadow.sm};
  z-index: ${zIndex.sticky};
`

const Title = styled.h1`
  flex: 1 1 auto;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${colors.textPrimary};
  text-transform: lowercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const RightSlot = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: ${space.xs};
`

const MobileTopBar = ({ onMenuClick, title, right }) => (
  <Bar>
    <IconButton
      edge="start"
      aria-label="open menu"
      onClick={onMenuClick}
      style={{ padding: '8px' }}
    >
      <MenuIcon />
    </IconButton>
    <Title>{title}</Title>
    {right ? <RightSlot>{right}</RightSlot> : null}
  </Bar>
)

MobileTopBar.propTypes = {
  onMenuClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  right: PropTypes.node
}

export default MobileTopBar
